import React, { useEffect, useState } from 'react';
import { Grid, Menu, MenuItem, ListSubheader, Checkbox, FormControlLabel } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import _keyBy from 'lodash/keyBy';
import _isEmpty from 'lodash/isEmpty';
import TopbarMenu from './topbar/TopbarMenu';
import SidebarMenu from './sidebar/SidebarMenu';
import SidebarList from './sidebar/SidebarList';
import SidebarListDose from './sidebar/SidebarListDose';
import SidebarListJourney from './sidebar/SidebarListJourney';
import Topbar from './topbar/Topbar';
import LeftbarDealership from './dealership/LeftbarDealership';
import LeftbarJourney from './journey/LeftbarJourney';
import RightbarJourney from './journey/RightbarJourney';
import AddNewLevelMenu from './journey/AddNewLevelMenu';
import LeftDailyDoseContent from './dailydose/LeftDailyDoseContent';
import LeftPlanContent from './plan/LeftPlanContent';
import RightPlanContent from './plan/RightPlanContent';
import MainLayoutStyles from '../styles/MainLayoutStyle';
import Report from './report/Report';
import {
  showProgress,
  // getSelectedRoleID,
  getSelectedDealershipFilters,
  // getRoleList,
  getAddCollectionFilters,
  getCustomDepartment,
} from '../redux/actions/DealershipActions';

import RightTabLists from './dealership/RightTabLists';
import RightTabListsJourney from './journey/RightTabLists';
import RightTabListLevel from './journey/AddLevelLayout';
import RightDailyDoseContent from './dailydose/RightDailyDoseContent';
import SidebarListPlan from './sidebar/SidebarListPlan';
import LeftSideCollection from './collections/LeftSideCollection';
import RightSideCollection from './collections/RightSideCollection';
import SidebarListCollections from './sidebar/SidebarListCollections';
import Service from '../apis/service';
import { ErrorToast, searchArray, getFilteredList, filterAIRoleplayTopics } from './utils/Utils';
import CollectionFilter from './collections/CollectionFilter';
import StoryFilter from './dailydose/StoryFilter';
import CustomGroupDealershipContent from './dealership/CustomGroupDealershipContent';
import DepartmentDealershipContent from './dealership/DepartmentDealershipContent';
import SidebarListTOM from './TopicOfTheMonth/SidebarListTOM';
import TOMMainContent from './TopicOfTheMonth/TOMMainContent';
import SidebarListPx from './PXDashboard/SidebarListPx';
import PXMainContent from './PXDashboard/PXMainContent';
import SidebarListCurriculum from './rockedCurriculum/SidebarListCurriculum';
import Tenure from './rockedCurriculum/Tenure';
import SidebarListFuel from './rockedFuel/SidebarListFuel';
import Fuels from './rockedFuel/Fuels';
import FuelTemplate from './rockedFuel/FuelTemplates';
import SidebarListTopics from './topics/SidebarListTopics';
import LeftsideTopic from './topics/LeftsideTopic';
import RightsideTopic from './topics/RightsideTopic';
import { apiEndpoints } from '../constants/apiEndpoints';
import LeftsideCert from './certification/LeftsideCert';
import RightsideCert from './certification/RightsideCert';
import { SidebarListCerts } from './certification/SidebarListCerts';
import { AIMainContent } from './AIRoleplay/AIMainContent';
import { SidebarListAI } from './AIRoleplay/SidebarList';
import { EXCLUDE_TOP_BAR, MAIN_TAB_ID_ARRAY, MIDDLE_CONTENT_PAGES } from '../constants/main';
import MainContainer from './categories/components/MainContainer';
import SidebarListCategory from './categories/components/SidebarListCategory';
import CurriculumCollections from './rockedCurriculum/CurriculumCollections';
import SearchBox from './shared/SearchBox';
import useAiExercise from './journey/hooks/useAiExercise';
import LeftSideQuiz from './quiz/components/LeftSideQuiz';
import RightSideQuiz from './quiz/components/RightSideQuiz';
import SidebarListQuiz from './quiz/components/SidebarListQuiz';
import ZeroState from './common/ZeroState';
import FileIcon from '../assets/FileIcon';
import AddSeries from './quiz/components/AddSeries';
import useFetchDetails from './dealership/hooks/useFetchDetails';

const MainLayout = () => {
  const classes = MainLayoutStyles();
  const dispatch = useDispatch();
  const { fetchDetails } = useAiExercise();
  const { fetchCgDetails } = useFetchDetails();
  const dealershipList = useSelector((state) => state.GetDealershipList.dealershiplist);
  const dealershipID = useSelector((state) => state.getDealershipID);
  const mainTabID = useSelector((state) => state.getMainTabID);
  const selectedLevelID = useSelector((state) => state.getSelectedLevelID);
  // const departmentID = useSelector((state) => state.getDepartment);
  const journeylist = useSelector((state) => state.GetJourneyList.journeylist);
  const planList = useSelector((state) => state.GetPlanList.planlist);
  const topicOfTheMonthDatesList = useSelector((state) => state.getTopicOfTheMonth.datesList); // moved ToM to dev panel
  const filters = useSelector((state) => state.getAddCollectionFilters.collectionfilters);
  const selecteddealershipfilters = useSelector(
    (state) => state.getSelectedDealershipFilters.selecteddealershipsfilter,
  );
  const quizSeriesList = useSelector((state) => state?.getQuizSeriesList?.quizSeriesList) || [];
  const collectionlist = useSelector((state) => state.GetCollectionList.collectionlist);
  const pxUserList = useSelector((state) => state.pxDashboardData.userList);
  const rolesList = useSelector((state) => state.rockedCurriculumData.rolesList);
  const categoriesList = useSelector((state) => state.rockedFuelData.categoriesList);
  const topicsList = useSelector((state) => state.topicsData.topicsList);
  const certList = useSelector((state) => state.certificateData.certList);
  const allCatList = useSelector((state) => state.aiRoleplayData.exerciseCategories || []);
  const levelIds = useSelector((state) => state.JourneyDetails.journeydetails.levels);
  const pubDates = useSelector((state) => state.getPubDates.pubDates)?.sort((a, b) => {
    const aDate = new Date(a);
    const bDate = new Date(b);
    return bDate.getTime() - aDate.getTime();
  });

  const [value, setValue] = React.useState(0);
  const [anchorEl, setAnchorEl] = useState(null);
  const [menuValue, setMenuValue] = React.useState(0);
  const [searchVal, setSearchVal] = useState('');
  const [searchJVal, setSearchJVal] = useState('');
  const [searchPVal, setSearchPVal] = useState('');
  const [searchTOMDateValue, setSearchTOMDateValue] = useState(''); // ToM
  const [searchPxVal, setSearchPxVal] = useState('');
  const [searchRole, setSearchRole] = useState('');
  const [searchCategory, setSearchCategory] = useState('');
  const [searchTopic, setSearchTopics] = useState('');
  const [searchCert, setSearchCert] = useState('');
  const [searchAiCat, setSearchAiCat] = useState('');
  // const [menus, setMenus] = React.useState([]);
  const [showAddNewLMenu, setShowAddNewLMenu] = React.useState(false);
  const [showEditLMenu, setShowEditLMenu] = React.useState(false);
  const [filterArray, setFilterArray] = React.useState([]);
  const [filterSArray, setFilterSArray] = React.useState([]);
  const [filterList, setFilterList] = useState([]);
  const [filterListArray, setFilterListArray] = React.useState([]);
  const [colFilters, setColFilters] = React.useState({});
  const [storyFilters, setStoryFilters] = React.useState({});
  const [filterCollectionListArray, setFilterCollectionListArray] = React.useState([]);
  const [filterStoryListArray, setFilterStoryListArray] = React.useState([]);
  const [filterJArray, setFilterJArray] = React.useState([]);
  const [filterPArray, setFilterPArray] = React.useState([]);
  const [filterTOMArray, setFilterTOMArray] = React.useState([]); // ToM
  const [filterPxArray, setFilterPxArray] = React.useState([]);
  const [filterCurriculum, setFilterCurriculum] = React.useState([]);
  const [filterFuel, setFilterFuel] = React.useState([]);
  const [filterTopic, setFilterTopic] = React.useState([]);
  const [filterCert, setFilterCert] = React.useState([]);
  const [filterAI, setFilterAI] = React.useState([]);
  const [filterCArray, setFilterCArray] = React.useState([]);
  const [checkedActive, setCheckedActive] = React.useState(true);
  const [checkedInactive, setCheckedInactive] = React.useState(true);
  const [openQuizSeriesPopup, setOpenQuizSeriesPopup] = React.useState(false);

  const [sourceAdmin, setSourceAdmin] = React.useState(true);
  const [sourceBMW, setSourceBMW] = React.useState(true);
  const [pipelineStatus, setLeadPipelineStatus] = useState([]);

  // const IndexArray = [];
  // const SelectedDept = [];

  useEffect(() => {
    handleChange();
  }, []);
  useEffect(() => {
    if (menuValue) fetchCgDetails();
  }, [fetchCgDetails, menuValue]);
  useEffect(() => {
    setFilterList(selecteddealershipfilters);
  }, [selecteddealershipfilters]);
  useEffect(() => {
    setSearchVal('');
    setFilterArray(dealershipList);
    setFilterListArray(dealershipList);
    handleFilterActive();
  }, [dealershipList]);
  useEffect(() => {
    journeylist?.sort((a, b) => new Date(b.publishDate) - new Date(a.publishDate));
    setSearchJVal('');
    setFilterJArray(journeylist);
  }, [journeylist]);
  useEffect(() => {
    setFilterCArray(collectionlist);
    setFilterCollectionListArray(collectionlist);
  }, [collectionlist]);
  useEffect(() => {
    setSearchPVal('');
    setFilterPArray(planList);
  }, [planList]);

  // ToM
  useEffect(() => {
    setSearchTOMDateValue('');
    setFilterTOMArray(topicOfTheMonthDatesList);
  }, [topicOfTheMonthDatesList]);

  useEffect(() => {
    setSearchPxVal('');
    setFilterPxArray(pxUserList);
  }, [pxUserList]);

  useEffect(() => {
    setSearchRole('');
    setFilterCurriculum(rolesList);
  }, [rolesList]);

  useEffect(() => {
    setSearchCategory('');
    setFilterFuel(categoriesList);
  }, [categoriesList]);

  useEffect(() => {
    setSearchTopics('');
    setFilterTopic(topicsList);
  }, [topicsList]);

  useEffect(() => {
    setSearchCert('');
    setFilterCert(certList);
  }, [certList]);

  useEffect(() => {
    setSearchAiCat('');
    setFilterAI(allCatList);
  }, [allCatList]);

  useEffect(() => {
    const tempCatArr = [];
    filters?.categories.map((ele) => tempCatArr.push(ele.id));
    const tempExpArr = [];
    filters?.categories.map((ele) => tempExpArr.push(ele.id));
    setColFilters({
      searchTerm: '',
      departments: filters?.categories?.map((a) => a.name),
      expertiseLevel: filters?.expertiseLevels?.map((a) => a.name),
    });
  }, [filters]);

  useEffect(() => {
    setFilterSArray(pubDates);
    setFilterStoryListArray(pubDates);
  }, [pubDates]);

  useEffect(() => {
    setSearchVal('');
    setSearchJVal('');
    setSearchPVal('');
    if (mainTabID === 5 || mainTabID === 20) {
      fetchFilters();
    }
    if (mainTabID === 2) {
      setStoryFilters({
        searchTerm: '',
        types: ['VIDEO', 'PODCAST', 'NEWS ARTICLE', 'BLOG'],
      });
    }
  }, [mainTabID]);

  useEffect(() => {
    if (mainTabID === 0 && selectedLevelID !== 0) {
      fetchDetails(selectedLevelID);
    }
  }, [dispatch, fetchDetails, selectedLevelID, mainTabID]);

  useEffect(() => {
    const getLeadPipelineStatus = async () => {
      await Service.get(apiEndpoints.JOURNEY_SALES_PIPELINE_STATUS)
        .then((items) => {
          const pipelineStatusMap = _keyBy(items, 'id');
          setLeadPipelineStatus(pipelineStatusMap);
        })
        .catch(() => {});
    };

    const getCustomDepartmentAndRole = async () => {
      try {
        const response = await Service.get(apiEndpoints.JOURNEY_CUSTOM_DEPARTMENT);
        dispatch(getCustomDepartment('set', response));
      } catch (err) {
        console.log(err);
      }
    };

    if (dealershipID) {
      getLeadPipelineStatus();
      getCustomDepartmentAndRole();
    }
    setMenuValue(0);
  }, [dealershipID]);

  useEffect(() => {
    handleFilterActive();
  }, [filterList]);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleSearchChange = (e) => {
    const input = e.target.value;
    setSearchVal(input);
    const filteredArray = getFilteredList(filterListArray, input, ['name', 'id']);
    setFilterArray(filteredArray);
  };
  const handleSearchJourney = (e) => {
    const input = e.target.value;
    setSearchJVal(input);
    const filteredJArray = getFilteredList(journeylist, input, ['title', 'id']);
    setFilterJArray(filteredJArray);
  };
  const handleSearchPlan = (e) => {
    const input = e.target.value;
    setSearchPVal(input);
    const filteredPArray = getFilteredList(planList, input, ['title', 'id']);
    setFilterPArray(filteredPArray);
  };

  // ToM
  const handleSearchTOMDates = (e) => {
    const input = e.target.value;
    setSearchTOMDateValue(input);
    setFilterTOMArray(searchArray(topicOfTheMonthDatesList || [], ['title'], input));
  };

  const handleSearchPxUsers = (e) => {
    const input = e.target.value;
    setSearchPxVal(input);
    const filteredArrayTemp = getFilteredList(pxUserList, input, ['name']);
    setFilterPxArray(filteredArrayTemp);
  };

  const handleSearchCurriculumRoles = (e) => {
    const input = e.target.value;
    setSearchRole(input);
    const filteredRoles = getFilteredList(rolesList, input, ['title']);
    setFilterCurriculum(filteredRoles);
  };

  const handleSearchFuelCagegories = (e) => {
    const input = e.target.value;
    setSearchCategory(input);
    const filteredCategories = getFilteredList(categoriesList, input, ['title']);
    setFilterFuel(filteredCategories);
  };

  const handleSearchTopics = (e) => {
    const input = e.target.value;
    setSearchTopics(input);
    const filteredTopics = getFilteredList(topicsList, input, ['title', 'id']);
    setFilterTopic(filteredTopics);
  };

  const handleSearchCerts = (e) => {
    const input = e.target.value;
    setSearchCert(input);
    const filteredCerts = getFilteredList(certList, input, ['name', 'id']);
    setFilterCert(filteredCerts);
  };

  const handleSearchAICategory = (e) => {
    const input = e.target.value;
    setSearchAiCat(input);
    const filteredCats = filterAIRoleplayTopics(allCatList, input);
    setFilterAI(filteredCats);
  };

  const handleChange = (newValue) => {
    setValue(newValue);
  };
  // const handleRightMenuChange = (event, newValue) => {
  //   if (IndexArray[newValue] === undefined) {
  //     dispatch(getDepartment(0));
  //   } else {
  //     dispatch(getDepartment(IndexArray[newValue]));
  //   }
  //   // setSelectedDepartment(SelectedDept[newValue]);
  // };
  const handleOpenLevelPopup = () => {
    setShowAddNewLMenu(true);
    setShowEditLMenu(false);
  };

  const handleEditLevelPopup = () => {
    setShowAddNewLMenu(() => false);
    setShowEditLMenu(() => true);
  };
  const handleCloseLevelPopup = () => {
    setShowAddNewLMenu(() => false);
    setShowEditLMenu(() => false);
  };
  const handleFilterChange = (e) => {
    const tempArr = filterList;
    const index = tempArr.indexOf(e.target.value);
    if (e.target.value === 'Enabled' && !e.target.checked) {
      if (checkedInactive) {
        setCheckedActive(false);
        tempArr?.splice(index, 1);
      }
    } else if (e.target.value === 'Enabled' && e.target.checked) {
      setCheckedActive(true);
      tempArr?.push(e.target.value);
    } else if (e.target.value === 'Disabled' && !e.target.checked) {
      if (checkedActive) {
        setCheckedInactive(false);
        tempArr?.splice(index, 1);
      }
    } else if (e.target.value === 'Disabled' && e.target.checked) {
      setCheckedInactive(true);
      tempArr?.push(e.target.value);
    } else if (tempArr?.indexOf(e.target.value) > -1) {
      tempArr?.splice(index, 1);
    } else {
      tempArr?.push(e.target.value);
    }
    setFilterList([...tempArr]);
    dispatch(getSelectedDealershipFilters([...tempArr]));
  };

  const handleFilterChangeSource = (e) => {
    const tempArr = filterList;
    const index = tempArr.indexOf(e.target.value);
    if (e.target.value === 'ADMIN' && !e.target.checked) {
      if (sourceBMW) {
        setSourceAdmin(false);
        tempArr?.splice(index, 1);
      }
    } else if (e.target.value === 'ADMIN' && e.target.checked) {
      setSourceAdmin(true);
      tempArr?.push(e.target.value);
    } else if (e.target.value === 'BMW' && !e.target.checked) {
      if (sourceAdmin) {
        setSourceBMW(false);
        tempArr?.splice(index, 1);
      }
    } else if (e.target.value === 'BMW' && e.target.checked) {
      setSourceBMW(true);
      tempArr?.push(e.target.value);
    } else if (tempArr?.indexOf(e.target.value) > -1) {
      tempArr?.splice(index, 1);
    } else {
      tempArr?.push(e.target.value);
    }
    setFilterList([...tempArr]);
    dispatch(getSelectedDealershipFilters([...tempArr]));
  };

  const handleFilterActive = () => {
    let filteredArray = dealershipList;
    if (!filterList?.length) {
      filteredArray = dealershipList;
      setFilterArray(dealershipList);
      setFilterListArray(dealershipList);
      setSearchVal('');
    } else if (filterList?.indexOf('Enabled') > -1 && filterList?.indexOf('Disabled') > -1) {
      filteredArray = dealershipList;
      setFilterArray(dealershipList);
      setFilterListArray(dealershipList);
      setSearchVal('');
    } else if (filterList?.indexOf('Enabled') > -1 && filterList?.indexOf('Disabled') === -1) {
      filteredArray = dealershipList.filter((item) => item.enabled);
      setFilterArray(filteredArray);
      setFilterListArray(filteredArray);
      setSearchVal('');
    } else if (filterList?.indexOf('Enabled') === -1 && filterList?.indexOf('Disabled') > -1) {
      filteredArray = dealershipList.filter((item) => !item.enabled);
      setFilterArray(filteredArray);
      setFilterListArray(filteredArray);
      setSearchVal('');
    }
    if (!filterList?.length) {
      setFilterArray(filteredArray);
      setFilterListArray(filteredArray);
      setSearchVal('');
    } else if (filterList?.indexOf('ADMIN') > -1 && filterList?.indexOf('BMW') > -1) {
      setFilterArray(filteredArray);
      setFilterListArray(filteredArray);
      setSearchVal('');
    } else if (filterList?.indexOf('ADMIN') > -1 && filterList?.indexOf('BMW') === -1) {
      filteredArray = filteredArray.filter((item) => item.source === 'ADMIN');
      setFilterArray(filteredArray);
      setFilterListArray(filteredArray);
      setSearchVal('');
    } else if (filterList?.indexOf('ADMIN') === -1 && filterList?.indexOf('BMW') > -1) {
      filteredArray = filteredArray.filter((item) => item.source === 'BMW');
      setFilterArray(filteredArray);
      setFilterListArray(filteredArray);
      setSearchVal('');
    }
    const tempArr = [];
    filterList?.forEach((filterItem) => {
      const leadPipelineIds = Object.keys(pipelineStatus).map((k) => `${k}`);
      if (filteredArray?.length && leadPipelineIds.includes(filterItem)) {
        const tmpArr = filteredArray.filter((item) => `${item.leadPipeline}` === filterItem);
        tmpArr.forEach((item) => {
          tempArr.push(item);
        });
        setFilterArray(tempArr);
        setFilterListArray(tempArr);
        setSearchVal('');
      }
      // if (filterItem === 'Lead') {
      //   const tmpArr = filteredArray.filter((item) => item.leadPipeline === 1);
      //   tmpArr.forEach((item) => {
      //     tempArr.push(item);
      //   });
      //   setFilterArray(tempArr);
      //   setFilterListArray(tempArr);
      //   setSearchVal('');
      // } else if (filterItem === 'Demo Scheduled') {
      //   const tmpArr = filteredArray.filter((item) => item.leadPipeline === 2);
      //   tmpArr.forEach((item) => {
      //     tempArr.push(item);
      //   });
      //   setFilterArray(tempArr);
      //   setFilterListArray(tempArr);
      //   setSearchVal('');
      // } else if (filterItem === 'Demo Completed') {
      //   const tmpArr = filteredArray.filter((item) => item.leadPipeline === 3);
      //   tmpArr.forEach((item) => {
      //     tempArr.push(item);
      //   });
      //   setFilterArray(tempArr);
      //   setFilterListArray(tempArr);
      //   setSearchVal('');
      // } else if (filterItem === 'Contract Signed') {
      //   const tmpArr = filteredArray.filter((item) => item.leadPipeline === 4);
      //   tmpArr.forEach((item) => {
      //     tempArr.push(item);
      //   });
      //   setFilterArray(tempArr);
      //   setFilterListArray(tempArr);
      //   setSearchVal('');
      // } else if (filterItem === 'Paying') {
      //   const tmpArr = filteredArray.filter((item) => item.leadPipeline === 5);
      //   tmpArr.forEach((item) => {
      //     tempArr.push(item);
      //   });
      //   setFilterArray(tempArr);
      //   setFilterListArray(tempArr);
      //   setSearchVal('');
      // }
    });
  };
  const closeQuizSeriesPopup = () => setOpenQuizSeriesPopup(false);
  const handleClose = () => {
    setAnchorEl(null);
  };
  const filterCondition = !(
    filterList?.indexOf('Enabled') === -1 ||
    filterList?.indexOf('Disabled') === -1 ||
    filterList?.indexOf('1') > -1 ||
    filterList?.indexOf('2') > -1 ||
    filterList?.indexOf('3') > -1 ||
    filterList?.indexOf('4') > -1 ||
    filterList?.indexOf('5') > -1 ||
    filterList?.indexOf('6') > -1
  );
  const fetchFilters = async () => {
    dispatch(showProgress(true));
    await Service.get(apiEndpoints.COLLECTION_FILTERS)
      .then((response) => {
        dispatch(getAddCollectionFilters(response));
        dispatch(showProgress(false));
      })
      .catch((error) => {
        ErrorToast(error);
        dispatch(showProgress(false));
      });
  };
  const dealershipMenu = (
    <Menu
      id="simple-menu"
      anchorEl={anchorEl}
      keepMounted
      open={Boolean(anchorEl)}
      onClose={handleClose}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'left',
      }}
    >
      <ListSubheader>Dealership Status</ListSubheader>
      <MenuItem style={{ padding: '0px' }}>
        <FormControlLabel
          classes={{
            root: classes.fullWidth,
          }}
          label="Enabled"
          control={<Checkbox value="Enabled" defaultChecked checked={checkedActive} onChange={handleFilterChange} />}
        />
      </MenuItem>
      <MenuItem style={{ padding: '0px' }}>
        <FormControlLabel
          classes={{
            root: classes.fullWidth,
          }}
          label="Disabled"
          control={<Checkbox value="Disabled" defaultChecked checked={checkedInactive} onChange={handleFilterChange} />}
        />
      </MenuItem>
      <ListSubheader>Dealership Source</ListSubheader>
      <MenuItem style={{ padding: '0px' }}>
        <FormControlLabel
          classes={{
            root: classes.fullWidth,
          }}
          label="ADMIN"
          control={<Checkbox value="ADMIN" defaultChecked checked={sourceAdmin} onChange={handleFilterChangeSource} />}
        />
      </MenuItem>
      <MenuItem style={{ padding: '0px' }}>
        <FormControlLabel
          classes={{
            root: classes.fullWidth,
          }}
          label="BMW"
          control={<Checkbox value="BMW" defaultChecked checked={sourceBMW} onChange={handleFilterChangeSource} />}
        />
      </MenuItem>
      <ListSubheader>Sales Pipeline Status</ListSubheader>
      {!_isEmpty(pipelineStatus) &&
        Object.values(pipelineStatus).map((ps) => (
          <MenuItem key={ps.id} style={{ padding: '0px' }}>
            <FormControlLabel
              classes={{
                root: classes.fullWidth,
              }}
              label={ps.title}
              control={
                <Checkbox
                  checked={selecteddealershipfilters?.indexOf(`${ps.id}`) > -1}
                  value={ps.id}
                  onChange={handleFilterChange}
                />
              }
            />
          </MenuItem>
        ))}
    </Menu>
  );
  const getSearchComponent = () => {
    switch (mainTabID) {
      case 0:
        return (
          <Grid item style={{ height: '7vh' }}>
            <SearchBox
              handleSearchChange={handleSearchJourney}
              searchVal={searchJVal}
              placeholder="Search Journey"
              filterCondition
            />
          </Grid>
        );
      case 1:
        return (
          <Grid item style={{ height: '7vh' }}>
            <SearchBox
              handleSearchChange={handleSearchChange}
              searchVal={searchVal}
              placeholder="Search Dealership"
              filterCondition={filterCondition}
              menu={dealershipMenu}
              handleClick={handleClick}
            />
          </Grid>
        );
      case 2:
        return (
          <Grid item>
            <StoryFilter
              list={filterStoryListArray}
              handleChange={(l) => setFilterSArray(l)}
              initialFilters={storyFilters}
            />
          </Grid>
        );
      case 3:
        return (
          <Grid item>
            <SearchBox
              handleSearchChange={handleSearchPlan}
              searchVal={searchPVal}
              placeholder="Search Plans"
              filterCondition
            />
          </Grid>
        );
      case 5:
        return (
          <Grid item>
            <CollectionFilter
              list={filterCollectionListArray}
              handleChange={(l) => setFilterCArray(l)}
              initialFIlters={colFilters}
            />
          </Grid>
        );
      case 12:
        return (
          <Grid item>
            <SearchBox
              handleSearchChange={handleSearchPxUsers}
              searchVal={searchPxVal}
              placeholder="Search PX Users"
              filterCondition
            />
          </Grid>
        );

      case 14:
        return (
          <Grid item>
            <SearchBox
              handleSearchChange={handleSearchCurriculumRoles}
              searchVal={searchRole}
              placeholder="Search Curriculum"
              filterCondition
            />
          </Grid>
        );

      // ToM
      case 13:
        return (
          <Grid item>
            <SearchBox
              handleSearchChange={handleSearchTOMDates}
              searchVal={searchTOMDateValue}
              placeholder="Search TOM"
              filterCondition
            />
          </Grid>
        );

      case 15:
        return (
          <Grid item>
            <SearchBox
              handleSearchChange={handleSearchFuelCagegories}
              searchVal={searchCategory}
              placeholder="Search"
              filterCondition
            />
          </Grid>
        );

      case 16:
        return (
          <Grid item>
            <SearchBox
              handleSearchChange={handleSearchTopics}
              searchVal={searchTopic}
              placeholder="Search Topics"
              filterCondition
            />
          </Grid>
        );

      case 17:
        return (
          <Grid item>
            <SearchBox
              handleSearchChange={handleSearchCerts}
              searchVal={searchCert}
              placeholder="Search "
              filterCondition
            />
          </Grid>
        );

      case 18:
        return (
          <Grid item>
            <SearchBox
              handleSearchChange={handleSearchAICategory}
              searchVal={searchAiCat}
              placeholder="Search "
              filterCondition
            />
          </Grid>
        );

      default:
        return '';
    }
  };
  const getLeftContent = () => {
    switch (mainTabID) {
      case 0:
        return (
          <Grid item xs={5} style={{ height: '61vh', marginTop: '2vh' }}>
            <LeftbarJourney />
          </Grid>
        );
      case 1:
        return (
          <Grid item xs={5}>
            <LeftbarDealership customStyles={classes.leftbarScroll} />
          </Grid>
        );
      case 2:
        return (
          <Grid item xs={5} style={{ height: '64vh' }}>
            <LeftDailyDoseContent />
          </Grid>
        );
      case 3:
        return (
          <Grid item xs={6} style={{ height: '64vh' }}>
            <LeftPlanContent />
          </Grid>
        );
      case 4:
        return (
          <Grid item xs={12} style={{ height: '84vh', overflowY: 'auto' }}>
            <Report />
          </Grid>
        );
      case 5:
        return (
          <Grid item xs={5}>
            <LeftSideCollection />
          </Grid>
        );
      case 14:
        return (
          <Grid item xs={5}>
            <Tenure />
          </Grid>
        );
      case 15:
        return (
          <Grid item xs={5}>
            <Fuels />
          </Grid>
        );
      case 16:
        return (
          <Grid item xs={5}>
            <LeftsideTopic />
          </Grid>
        );
      case 17:
        return (
          <Grid item xs={5}>
            <LeftsideCert />
          </Grid>
        );
      case 22:
        return (
          <Grid item xs={quizSeriesList?.length > 0 ? 5 : 12}>
            {quizSeriesList?.length > 0 ? (
              <LeftSideQuiz />
            ) : (
              <>
                <ZeroState
                  Icon={FileIcon}
                  title="No Quiz Series Added."
                  text="Add a quiz series."
                  style={{ paddingBottom: '100px', marginTop: '40px' }}
                  cardWidth="100%"
                  btnText="+ Add Quiz Series"
                  btnAction={() => {
                    setOpenQuizSeriesPopup(true);
                  }}
                />
                {openQuizSeriesPopup && <AddSeries isOpen close={closeQuizSeriesPopup} />}
              </>
            )}
          </Grid>
        );
      default:
        return null;
    }
  };
  const getTabLists = () => {
    switch (mainTabID) {
      case 0:
        if (levelIds?.length === 0) {
          return <RightTabListLevel clickFn={handleOpenLevelPopup} />;
        }
        return <RightTabListsJourney onOpenLevelPopup={handleOpenLevelPopup} onEditLevelPopup={handleEditLevelPopup} />;
      default:
        return '';
    }
  };
  const getRightPlanContent = () => {
    switch (mainTabID) {
      case 3:
        return (
          <Grid item xs={6}>
            <RightPlanContent />
          </Grid>
        );
      default:
        return null;
    }
  };
  const getRightContent = () => {
    switch (mainTabID) {
      case 1:
        return (
          <>
            <RightTabLists setMenuValue={setMenuValue} menuValue={menuValue} />
            <div className={classes.rightbar2}>
              {menuValue === 0 ? <DepartmentDealershipContent /> : <CustomGroupDealershipContent />}
            </div>
          </>
        );
      case 0:
        return <RightbarJourney onEditLevelPopup={handleEditLevelPopup} value={0} />;
      case 2:
        return <RightDailyDoseContent />;
      case 5:
        return <RightSideCollection />;
      case 14:
        return <CurriculumCollections />;
      case 15:
        return <FuelTemplate />;
      case 16:
        return <RightsideTopic />;
      case 17:
        return <RightsideCert />;
      case 22:
        return <RightSideQuiz />;
      default:
        return '';
    }
  };
  const getSidebarWithSearchContent = () => {
    switch (mainTabID) {
      case 0:
        return <SidebarListJourney filterArray={filterJArray} />;
      case 1:
        return <SidebarList filterArray={filterArray} />;
      case 2:
        return <SidebarListDose filterArray={filterSArray} />;
      case 3:
        return <SidebarListPlan filterArray={filterPArray} />;
      case 5:
        return <SidebarListCollections filterArray={filterCArray} />;
      case 12:
        return <SidebarListPx filterArray={filterPxArray} />;

      // ToM
      case 13:
        return <SidebarListTOM filterArray={filterTOMArray} />;

      case 14:
        return <SidebarListCurriculum filterArray={filterCurriculum} />;

      case 15:
        return <SidebarListFuel filterArray={filterFuel} />;

      case 16:
        return <SidebarListTopics filterArray={filterTopic} />;

      case 17:
        return <SidebarListCerts filterArray={filterCert} />;

      case 18:
        return <SidebarListAI filterArray={filterAI} />;

      case 20:
        return <SidebarListCategory filterArray={filterPArray} />;
      case 22:
        return <SidebarListQuiz />;
      default:
        return '';
    }
  };
  const getSidebar = () => {
    const sidebar = MAIN_TAB_ID_ARRAY.map((item) =>
      item === mainTabID ? (
        <Grid
          item
          className={
            // eslint-disable-next-line no-nested-ternary
            item === 1 || item === 0
              ? classes.sidebarDealership
              : item !== 20 && item !== 22
              ? classes.sidebar3
              : classes.sidebarCategory
          }
          id="sidebar_id"
        >
          {getSidebarWithSearchContent()}
        </Grid>
      ) : (
        ''
      ),
    );
    return sidebar;
  };

  const getMainContent = () => {
    switch (mainTabID) {
      case 12:
        return <PXMainContent />;

      default:
        return '';
    }
  };

  const getMiddleContent = () => {
    switch (mainTabID) {
      // ToM
      case 13:
        return <TOMMainContent />;
      case 18:
        return <AIMainContent />;
      case 20:
        return <MainContainer />;
      default:
        return '';
    }
  };

  return (
    <div>
      <TopbarMenu />
      <Grid container direction="row" style={{ maxHeight: '91vh' }}>
        <Grid item className={classes.sidebarBox}>
          <Grid container direction="column" className={classes.sidebarDose}>
            <Grid item className={classes.tabBar1}>
              <SidebarMenu selectedTab={mainTabID} type={0} />
              <SidebarMenu selectedTab={mainTabID} type={1} />
              <SidebarMenu selectedTab={mainTabID} type={2} />
              {/* <SidebarMenu selectedTab={mainTabID} type={3} />
              <SidebarMenu selectedTab={mainTabID} type={4} /> */}
              <SidebarMenu selectedTab={mainTabID} type={6} />
              {/* ToM */}
              <SidebarMenu selectedTab={mainTabID} type={7} />
              <SidebarMenu selectedTab={mainTabID} type={8} />
              <SidebarMenu selectedTab={mainTabID} type={9} />
              <SidebarMenu selectedTab={mainTabID} type={11} />
            </Grid>
            {getSearchComponent()}
            {getSidebar()}
          </Grid>
        </Grid>
        <Grid item style={{ flexGrow: '0', maxWidth: '72%', flexBasis: '80%' }}>
          {EXCLUDE_TOP_BAR.includes(mainTabID) ? (
            getMainContent()
          ) : (
            <Grid container direction="column">
              <Grid item className={classes.topbar}>
                <Topbar value={value} />
              </Grid>
              {MIDDLE_CONTENT_PAGES.includes(mainTabID) ? (
                <Grid item className={classes.middleContent}>
                  {getMiddleContent()}
                </Grid>
              ) : (
                <Grid item className={classes.topbar}>
                  <Grid container direction="row">
                    {getLeftContent()}
                    {getRightPlanContent()}
                    <Grid item xs={7}>
                      {getTabLists()}
                      {getRightContent()}
                    </Grid>
                  </Grid>
                </Grid>
              )}
            </Grid>
          )}
        </Grid>
      </Grid>
      {showAddNewLMenu && <AddNewLevelMenu open close={handleCloseLevelPopup} add selected="" edit={false} />}
      {showEditLMenu && <AddNewLevelMenu open close={handleCloseLevelPopup} add selected="" edit />}
    </div>
  );
};

export default MainLayout;
